module.exports = __webpack_public_path__ + "Assets/4ae7b88b-fb5d-4cb5-9888-78298ad2a973.eot";